var map = {
	"./TOP-white.svg": "4c0e",
	"./TOP.svg": "5f69",
	"./about_about.png": "145d",
	"./about_banner.png": "1e96",
	"./about_brand.png": "f4fd",
	"./about_brand_bk.png": "b63e",
	"./about_contact.png": "444e",
	"./about_de.png": "7df7",
	"./about_digital.png": "ba36",
	"./air_fe.png": "9795",
	"./air_img.png": "a0e7",
	"./amazon_alexa.png": "5621",
	"./app_banner.png": "072e",
	"./app_icon1.png": "64d8",
	"./app_icon2.png": "8339",
	"./app_icon3.png": "11ee",
	"./app_icon4.png": "0d4f",
	"./app_icon5.png": "4725",
	"./app_icon6.png": "be59",
	"./app_image.png": "8454",
	"./bulb_cs.png": "387f",
	"./bulb_djs.png": "993e",
	"./bulb_ds.png": "b38b",
	"./bulb_dz.png": "4c41",
	"./bulb_ig.png": "fd71",
	"./bulb_ld.png": "024b",
	"./bulb_ln.png": "05b5",
	"./bulb_qj.png": "848d",
	"./bulb_xq.png": "cd8f",
	"./bulb_zn.png": "0467",
	"./cert.png": "bc98",
	"./contact.png": "9fa8",
	"./contact_aimore.png": "2ec5",
	"./cp_banner.png": "98ab",
	"./cp_explain.png": "74c7",
	"./cp_photo1.png": "ddc5",
	"./cp_photo2.png": "0b2e",
	"./cp_photo3.png": "05a0",
	"./cp_photo4.png": "164f",
	"./dayu_logo.png": "7045",
	"./dayu_logo_mini.png": "6d25",
	"./dengdai.png": "3336",
	"./dengdai_xq.png": "8756",
	"./favicon.ico": "6e9c",
	"./ffs.png": "811f",
	"./ffs_img.png": "9618",
	"./ffs_img2.png": "cefc",
	"./flag.png": "5a25",
	"./google_assistant.png": "4750",
	"./home_about.png": "eda4",
	"./home_about_line.png": "95fd",
	"./home_banner.png": "ad38",
	"./home_banner2.png": "61d0",
	"./home_csyz.png": "a3af",
	"./home_detail.png": "10b3",
	"./home_quanwu_zhineng.png": "39f5",
	"./home_shfw.png": "1c2b",
	"./home_sjkf.png": "f692",
	"./home_xmpg.png": "8dcc",
	"./home_ysfb.png": "edb3",
	"./home_zhineng_dengpao.png": "66d0",
	"./home_zhineng_yiliao.png": "2425",
	"./huawei_hilink.png": "4119",
	"./icon-left.png": "f284",
	"./icon-right.png": "c9f6",
	"./icon_bytx.png": "c61e",
	"./icon_ccdj.png": "7172",
	"./icon_dsjs.png": "23b7",
	"./icon_dssz.png": "fac1",
	"./icon_gaoya.png": "10fe",
	"./icon_hwyk.png": "00bf",
	"./icon_jicha.png": "ae6c",
	"./icon_ldzn.png": "6839",
	"./icon_qqqh.png": "0fff",
	"./icon_sskz.png": "ee31",
	"./icon_tssz.png": "b42a",
	"./icon_wxwg.png": "23e2",
	"./icon_yjzx.png": "403d",
	"./icon_yykz.png": "4da2",
	"./icon_yyld.png": "c17f",
	"./icon_yyms.png": "268f",
	"./icon_zdh.png": "ffa4",
	"./icon_znld.png": "b27b",
	"./jd_dingdong.png": "c0dd",
	"./jd_jingyuzuo.png": "621d",
	"./language.svg": "6629",
	"./led_image.png": "99e7",
	"./led_jm.png": "53ac",
	"./led_xq.png": "83e9",
	"./logo.png": "cf05",
	"./module_b3132.png": "9c55",
	"./module_ir301.png": "d2df",
	"./module_wb201.png": "084a",
	"./module_wbe3.png": "c426",
	"./oppo_xiaoo.png": "5516",
	"./plug_fe.png": "eba8",
	"./plug_img.png": "77f5",
	"./qrcode_for_gh_55f843d0e539_1280.jpg": "7204",
	"./qrcode_for_gh_55f843d0e539_258.jpg": "95ee",
	"./siri.png": "195c",
	"./sl_banner1.png": "eb7d",
	"./sl_banner2.png": "ddc58",
	"./sl_banner3.png": "abc6",
	"./sl_banner4.png": "27f3",
	"./sl_image1.png": "3f5d",
	"./sl_image2.png": "2bb5",
	"./sl_image3.png": "d021",
	"./sl_image4.png": "de03",
	"./sl_slider1.png": "874c",
	"./sl_slider10.png": "0b55",
	"./sl_slider11.png": "c41e",
	"./sl_slider12.png": "7b19",
	"./sl_slider2.png": "c84e",
	"./sl_slider3.png": "288a",
	"./sl_slider4.png": "0b6d",
	"./sl_slider5.png": "8c93",
	"./sl_slider6.png": "d9e7",
	"./sl_slider7.png": "4760",
	"./sl_slider8.png": "037b",
	"./sl_slider9.png": "acc7",
	"./tg_advantage.png": "4a5d",
	"./tg_banner.png": "60cc",
	"./tg_explain.png": "5d7e",
	"./tg_photo1.png": "44be",
	"./tg_photo2.png": "9299",
	"./tg_photo3.png": "8ed2",
	"./tg_photo4.png": "294b",
	"./tiaomao_jingling.png": "5912",
	"./vivo_xiaov.png": "9e1b",
	"./voice_banner.png": "dbe2",
	"./voice_dpl.png": "b454",
	"./voice_dzd.png": "6fbf",
	"./voice_qll.png": "a46e",
	"./voice_quh.png": "c738",
	"./voice_ys.png": "9452",
	"./wwga.png": "ba2d",
	"./wwga_img.png": "8d9b",
	"./wwga_img2.png": "bade",
	"./wwhk.png": "8332",
	"./wwhk_img.png": "347a",
	"./wwhk_img2.png": "9401",
	"./xiaoai_tongxue.png": "815d",
	"./xiaodu.png": "2cd6",
	"./xiaoyi_zhushou.png": "e9e9",
	"./形状 3.png": "50ae",
	"./距离.svg": "dfcf",
	"./里程.svg": "a045"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";